import { cn } from '@/lib/cn'

/** 开关。用原生 checkbox + role="switch"，键盘与读屏都不用额外处理。 */
export function Toggle({
  label,
  description,
  checked,
  disabled,
  onChange,
}: {
  label: string
  description?: string
  checked: boolean
  disabled?: boolean
  onChange: (checked: boolean) => void
}) {
  return (
    <label
      className={cn(
        'flex cursor-pointer items-start gap-3 py-3',
        disabled && 'cursor-not-allowed opacity-60',
      )}
    >
      <span className="min-w-0 flex-1">
        <span className="block text-[15px]">{label}</span>
        {description && <span className="block text-[13px] text-ink-muted">{description}</span>}
      </span>
      <input
        type="checkbox"
        role="switch"
        className="peer sr-only"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      {/*
        焦点环画在外层：轨道用了 px-corners（clip-path），画在它身上会被裁掉。
        选中态用亮绿底 + 墨绿滑块，深浅两套都 ≥ 7:1；白滑块压在亮绿上只有 1.8:1。
      */}
      <span
        aria-hidden
        className="mt-0.5 shrink-0 rounded-sm p-[2px] peer-focus-visible:outline-2 peer-focus-visible:outline-brand-ink"
      >
        <span
          className={cn(
            'relative block h-6 w-11 px-corners transition-colors',
            // 滑块四周留 4px，正好躲开阶梯角的两级台阶，不会被切掉一角
            'after:absolute after:left-1 after:top-1 after:size-4 after:transition-transform',
            checked
              ? 'bg-brand after:translate-x-5 after:bg-on-brand'
              : 'bg-line-strong after:bg-white',
          )}
        />
      </span>
    </label>
  )
}
